<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.7071 1.79289C16.3166 1.40237 15.6834 1.40237 15.2929 1.79289L5.79289 11.2929C5.40237 11.6834 5.40237 12.3166 5.79289 12.7071L15.2929 22.2071C15.6834 22.5976 16.3166 22.5976 16.7071 22.2071C17.0976 21.8166 17.0976 21.1834 16.7071 20.7929L7.91421 12L16.7071 3.20711C17.0976 2.81658 17.0976 2.18342 16.7071 1.79289Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'BackIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
